import React from 'react'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'
import Field from '../Field'
import Label from '../Label'

const ABV: React.FC = () => {
    const { productData, abv } = useBrewDetailStore()
    const styleAbv =
        productData?.style?.abvMin &&
        productData?.style?.abvMax &&
        `${productData?.style?.abvMin}-${productData?.style?.abvMax}`

    const anyAbv = abv || styleAbv

    return (
        <Field title='ABV' gap='2'>
            <span className='text-dark text-lg font-bold'>
                {anyAbv || '--'}
                {anyAbv && '%'}{' '}
            </span>
        </Field>
    )
}

export default ABV
